
import { PatternStyle } from "@/data/caseStudyTypes";

interface PatternBackgroundProps {
  pattern: PatternStyle;
  id?: string;
}

export const PatternBackground = ({ pattern, id }: PatternBackgroundProps) => {
  return (
    <div className="absolute inset-0 bg-gradient-to-br from-white/90 to-white/60 overflow-hidden">
      <svg 
        viewBox="0 0 400 400" 
        className="absolute w-full h-full opacity-30"
        style={{ transform: `scale(1.8) rotate(${pattern.rotation}deg)` }}
      >
        <defs>
          <pattern id={`smallGrid-${id}`} width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M 20 0 L 0 0 0 20" fill="none" stroke={`${pattern.primary}33`} strokeWidth="1" />
          </pattern>
          <pattern id={`grid-${id}`} width="80" height="80" patternUnits="userSpaceOnUse">
            <rect width="80" height="80" fill={`url(#smallGrid-${id})`} />
            <path d="M 80 0 L 0 0 0 80" fill="none" stroke={`${pattern.primary}4D`} strokeWidth="2" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#grid-${id})`} />
        
        {/* Industry-specific Abstract Shapes */}
        {pattern.shapes.map((shape, i) => {
          if (shape.type === "circle") {
            return (
              <circle 
                key={i}
                cx={shape.cx} 
                cy={shape.cy} 
                r={shape.r} 
                fill={shape.fill} 
              />
            );
          } else if (shape.type === "path") {
            return (
              <path 
                key={i}
                d={shape.d} 
                fill={shape.fill || "none"} 
                stroke={shape.stroke} 
                strokeWidth={shape.strokeWidth}
              />
            );
          } else if (shape.type === "rect") {
            return (
              <rect 
                key={i}
                x={shape.x} 
                y={shape.y} 
                width={shape.width} 
                height={shape.height} 
                fill={shape.fill} 
              />
            );
          }
          return null;
        })}
      </svg>
    </div>
  );
};
